/**
 *  검색 키워드 리스트 검색 박스 모델
 */
export const SEARCH_WORD_LIST_SEARCH_DATA_MODEL = {
  /**
   *  ID
   */
  searchWordId: null,
  /**
   *  키워드
   */
  word: null,
  /**
   *  기간 검색
   */
  searchDate: {
    type: null,
    value: {
      startDate: null,
      endDate: null,
    },
  },
};

/**
 *  검색 키워드 리스트 검색 옵션 모델
 */
export const SEARCH_WORD_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  ID
   */
  searchWordId: null,
  /**
   *  키워드
   */
  word: null,
  /**
   *  기간 검색
   */
  searchDate: null,
};

/**
 *  주문 교환 리스트 정렬 옵션 모델
 */
export const SEARCH_WORD_LIST_SORT_OPTION_MODEL = {
  /**
   *  검색 횟수
   */
  count: 'descend',
  /**
   *  키워드 생성일
   */
  createDate: null,
};

/**
 *  검색 키워드 등록/편집 모델
 */
export const SEARCH_WORD_SAVE_MODEL = {
  /**
   *  키워드
   */
  word: null,
  /**
   *  검색 누적 횟수
   */
  count: null,
  /**
   *  키워드 중복 여부
   */
  isDuplicateWord: false,
  /**
   *  연관 검색 키워드 리스트
   */
  relatedKeywordList: {
    /**
     *  연관 검색 키워드 id 리스트
     */
    idList: [],
    /**
     *  연관 검색 키워드 name 리스트
     */
    nameList: [],
  },
  /**
   *  연관 검색 키워드 검색 리스트
   */
  relatedKeywordSelectList: [],
};
